import PropTypes from 'prop-types';
import React from 'react';
import './H1.sass';

const H1 = ({ xl, shadow, className, children, noGrow, style }) => {
	return <h1 className={`h1 select-none ${xl ? 'text-2xl md:text-3xl' : 'text-xl md:text-2xl'} ${noGrow ? 'flex-grow-0' : 'flex-grow'} font-bold text-left ${shadow ? 'h1--shadow ' : ''}${className}`} style={style}>
		{children}
	</h1>;
};

H1.propTypes = {
	children: PropTypes.any.isRequired,
	className: PropTypes.any,
	shadow: PropTypes.bool,
	xl: PropTypes.bool,
	noGrow: PropTypes.bool,
	style: PropTypes.object,
}

H1.defaultProps = {
	className: undefined,
	shadow: undefined,
	xl: undefined,
	noGrow: undefined,
	style: undefined,
}

export default H1;
